import React from 'react';

function Checkout(props) {
    return (
        <div>
            <h1>Checkout</h1>
        </div>
    );
}

export default Checkout;